import React from "react";
import { Section } from "../../../atoms/section";
import { Header } from "../../../molecules/header";
import { SavingsCard } from "../../../molecules/savings-card";
import { Flex } from "../../../atoms/flex";
import { useStore } from "../../../../store";
import { HashLink as Link } from "react-router-hash-link";
import { SECTIONS } from "../../../../constants/sections";
import { UNITS } from "../../../../constants/units";
import { MimboxData } from "../../../../interfaces/mimbox-data";
import { Icon } from "../../../atoms/icon";
import "./savings.css";

/**
 * Saved section
 */
export const Savings = () => {
  const { data = {} as MimboxData, loading } = useStore();
  const {
    economicPercentage = 0,
    waterSavedL = 0,
    carbonDioxideSavings = 0,
    microPlasticsSavings = 0,
  } = data;

  return (
    <Section id={SECTIONS.SAVINGS} className="small-padding">
      <Header title={SECTIONS.SAVINGS} loading={loading}></Header>
      <Flex className="section-content">
        <Link to={`#${SECTIONS.ECONOMY}`}>
          <SavingsCard
            text={SECTIONS.ECONOMY}
            value={Math.round(economicPercentage)}
            unit={UNITS.PERCENT}
            noUnitSpace
            isLoading={loading}
            icon="money"
          />
        </Link>
        <Link to={`#${SECTIONS.WATER}`}>
          <SavingsCard
            text={SECTIONS.WATER}
            value={Math.round(waterSavedL)}
            unit={UNITS.LITER}
            isLoading={loading}
            icon="water"
          />
        </Link>
        <Link to={`#${SECTIONS.CARBON_DIOXIDE}`}>
          <SavingsCard
            text={SECTIONS.CARBON_DIOXIDE}
            value={
              carbonDioxideSavings < 1
                ? Math.round(carbonDioxideSavings * 1000)
                : carbonDioxideSavings.toFixed(1)
            }
            unit={carbonDioxideSavings < 1 ? UNITS.GRAMS : UNITS.KILO}
            isLoading={loading}
            icon="carbon-dioxide"
          />
        </Link>
        <Link to={`#${SECTIONS.MICROPLASTICS}`}>
          <SavingsCard
            text={SECTIONS.MICROPLASTICS}
            value={
              microPlasticsSavings < 1000
                ? microPlasticsSavings.toFixed(1)
                : (microPlasticsSavings / 1000).toFixed(1)
            }
            unit={microPlasticsSavings < 1000 ? UNITS.GRAMS : UNITS.KILO}
            isLoading={loading}
            icon="microplastics"
          />
        </Link>
      </Flex>
      <Icon
        className="savings-fishes"
        type="fishes-thanks"
        size="xl"
        loading={loading}
      />
    </Section>
  );
};
